export default "__VITE_ASSET__Dx8bUUJ5__"